import { render } from "./ProviderAuthorizationButtons.vue?vue&type=template&id=30673bc4&scoped=true"
import script from "./ProviderAuthorizationButtons.vue?vue&type=script&lang=js"
export * from "./ProviderAuthorizationButtons.vue?vue&type=script&lang=js"

import "./ProviderAuthorizationButtons.vue?vue&type=style&index=0&id=30673bc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30673bc4"]])

export default __exports__